<template>
  <form class="searchForm" @submit.prevent="submit">
    <app-form-field id="searchQueryTextbox" title="zoeken" :show-label="false">
      <div class="searchInput">
        <input id="searchQueryTextbox" v-model="searchQuery" type="search" title="zoek" />
        <app-button data-qa="search-change-orders-button" class="searchButton" button-type="submit">
          <icon icon="search" />
        </app-button>

        <app-button
          class="toggleButton"
          data-qa="toggle-own-all-change-orders-button"
          @click="toggleOwnOrAllChangeOrders"
          >{{ toggleButtonText }}</app-button
        >
      </div>
    </app-form-field>
  </form>
</template>

<script>
import AppFormField from '@/components/generic/presentational/atoms/formField/FormField.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    AppFormField,
    AppButton,
    Icon,
  },
  emits: ['update'],
  data() {
    return {
      searchQuery: '',
      showOnlyOwnChangeOrders: true,
    }
  },
  computed: {
    ...mapGetters({
      stateShowOnlyOwnChangeOrders: 'changeOrders/showOnlyOwnChangeOrders',
      stateSearchQuery: 'changeOrders/searchQuery',
    }),
    toggleButtonText() {
      return this.showOnlyOwnChangeOrders ? 'Toon alle' : 'Toon mijn'
    },
  },
  mounted() {
    this.searchQuery = this.stateSearchQuery
    this.showOnlyOwnChangeOrders = this.stateShowOnlyOwnChangeOrders
  },
  methods: {
    async submit() {
      this.$store.commit('changeOrders/setFilterSearchQuery', this.searchQuery)
      await this.update()
    },
    async toggleOwnOrAllChangeOrders() {
      this.showOnlyOwnChangeOrders = !this.showOnlyOwnChangeOrders
      this.$store.commit(
        'changeOrders/setFilterShowOnlyOwnChangeOrders',
        this.showOnlyOwnChangeOrders
      )
      await this.update()
    },
    async update() {
      this.$emit('update')
    },
  },
}
</script>
<style lang="scss" scoped>
.searchForm {
  display: flex;
  flex-flow: row wrap;
}

.searchButton {
  border-radius: 0.125em;
}

.searchButton svg {
  width: 1em;
  height: 1em;
}

.toggleButton {
  margin-left: 25px;
}
</style>
